import { render, staticRenderFns } from "./LocationHistory.vue?vue&type=template&id=baa68780&scoped=true&"
import script from "./LocationHistory.vue?vue&type=script&lang=js&"
export * from "./LocationHistory.vue?vue&type=script&lang=js&"
import style0 from "./LocationHistory.vue?vue&type=style&index=0&id=baa68780&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa68780",
  null
  
)

export default component.exports